import { handleActions } from "redux-actions";
import {
  SET_FILTERS_DIRTY,
  SET_RESET_FILTERS,
  SET_SELECTED,
  SET_LOADING,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  UPDATE_DATES
} from "./eventLogsSaga";

export const initialState = {
  currentUser: {},
  tableInfo: {},
  isLoading: true,
  filtersDirty: false,
  options: {
    tableType: [
      { name: "Users", id: "users" },
      { name: "Stores", id: "clubready_stores" },
      { name: "Organizations", id: "organizations" }
    ],
    actions: [
      { name: "Not selected", id: "" },
      { name: "Create", id: "create" },
      { name: "Update", id: "update" },
      { name: "Destroy", id: "destroy" }
    ]
  },
  selectedRequestDates: {},
  selected: {
    action: { name: "Not selected", id: "" },
    tableType: { name: "Users", id: "users" },
    search: ""
  }
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      tableInfo: action.payload.tableInfo
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      filtersDirty: true
    }),
    [SET_SELECTED]: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        ...action.payload
      },
      filtersDirty: true
    }),
    [SET_RESET_FILTERS]: (state) => ({
      ...state,
      selected: { ...initialState.selected },
      selectedRequestDates: initialState.selectedRequestDates,
      filtersDirty: false
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    })
  },
  initialState
);
